module.exports = __webpack_public_path__ + "img/betting-app-left-banner.974a0ed.png";